import { Constants } from "./Constants";

export const pathToBreadcrumbMap = [
  {
    paths: ['/menu/InspectionDashboard'],
    breadcrumb: [(Constants.INSPECTION, 'Inspection'), (Constants.DASHBOARD, 'Dashboard')],
  },
  {
    paths: ['/menu/inspectionDashboard/inspectionDocument'],
    breadcrumb: [(Constants.INSPECTION_DASHBOARD, 'Inspection Dashboard'), (Constants.DOCUMENT, 'Document')],
  },
  {
    paths: [
      '/menu/interchangeDashboard/InspectionDocumentDetails',
    ],
    breadcrumb: [(Constants.INSPECTION_DASHBOARD, 'Inspection Dashboard'), (Constants.DOCUMENT, 'Document'), (Constants.DETAILS, 'Details')],
  },
  {
    paths: [
      '/menu/interchangeDashboard/InspectionDocumentCompare',
    ],
    breadcrumb: [(Constants.INSPECTION_DASHBOARD, 'Inspection Dashboard'), (Constants.DOCUMENT, 'Document'), 'Compare'],
  },
];
